import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  // const { pathname } = useLocation();
  const location=useLocation();

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, [pathname]);
  useEffect(()=>{
    window.scrollTo(0,0);
  },[location.key])
  return null;
}
